import { defineStore } from "pinia";
import { ref } from "vue";
import { useBase } from "@/utils/stores/base";
import { useFiltering } from "@/utils/stores/filtering";

const storeName = "ultimateBeneficialOwnerControlTypes";

export const useUltimateBeneficialOwnerControlTypeStore = defineStore(storeName, () => {
  const all = ref([]);
  const searchQuery = ref(null);
  const { baseFetchAll, watchRemoteResourceChange } = useBase(storeName);
  const { sortedResources } = useFiltering(all, searchQuery, "attributes.name");

  const fetchAll = async (errorCallback) => {
    all.value = await baseFetchAll("ultimate-beneficial-owner-control-types", errorCallback);
  };

  const subscribeToChanges = async () => {
    await watchRemoteResourceChange(storeName, () => {
      fetchAll();
    });
  };

  return {
    all,
    fetchAll,
    subscribeToChanges,
    sortedPropertyTypes: sortedResources
  };
});
